import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findGoodsQr= (id,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/list/${id}?`+params,
        method: 'GET'
    })
}
export const findParentAll= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/parents?`+params,
        method: 'GET'
    })
}
export const addGoodsQr = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/insertQr`,
        method: 'POST',
        data: data
    })
}
export const findBrand = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand`,
        method: 'GET'
    })
}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const deleteQr = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/${id}`,
        method: 'DELETE'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}
export const findGoodsByRootDepartId = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/findGoods?`+params,
        method: 'GET'
    })
}
export const batchDownloadQrCode = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/batchDownloadQrCode/${temp}`,
        method: 'get'
    })
}
export const batchDownloadQr = (ids) => {
    let temp = ids.join(",")
    let url=`${baseUrl}`+`/joins-sales-cloud/v1/qr/downloadGoodsQrCode/${temp}`
    window.open(url);
}
export const batchDownloadQr2 = (ids) => {
    let temp = ids.join(",")
    let url=`${baseUrl}`+`/joins-sales-cloud/v1/qr/downloadZip/${temp}`
    window.open(url);
}
export const downloadQr = () => {
   window.open('http://192.168.3.100:5200/joins-sales-cloud/v1/qr/batchDownloadQrCode');
}